import { useLanguage } from "../../LanguageContext";
import translation from "../../Translations/translation.json";
import "./Faq.css";

const Faq = () => {
  const { toggleLanguage, language } = useLanguage();

  const translate = (key) => {
    const langData = translation[language] || translation["en"];
    const keys = key.split(".");
    const result = keys.reduce((obj, keyPart) => obj?.[keyPart], langData);
    return result || key;
  };
  return (
    <div className="faq-pg">
      <div className="faq-page">
        <div className="container ">
          <div className="row">
            <div className="about-howto-create-token ">
              <h4>{translate("generalFaq.heading")}</h4>
            </div>
            <div
              className="accordion accordion-flush"
              id="accordionFlushExample"
            >
              {/* 1 */}
              {translate("generalFaq.questions")?.map((que, i) => (
                <div className="accordion-item" key={i}>
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#flush-coll-${i}`}
                      aria-expanded="false"
                      aria-controls={`flush-coll-${i}`}
                    >
                      {que.question}
                    </button>
                  </h2>
                  <div
                    id={`flush-coll-${i}`}
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      {que.answer.includes("\n") ? (
                        <ul>
                          {que.answer.split("\n").map((indi, i) => (
                            <li key={i}>{indi}</li>
                          ))}
                        </ul>
                      ) : (
                        <ul>
                          <li>{que.answer}</li>
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-6 col-12">
              <div className="about-howto-create-token ">
                <h4>{translate("powDexFaq.heading")}</h4>
              </div>
              <div
                className="accordion accordion-flush"
                id="accordionFlushExample"
              >
                {/* 1 */}
                {translate("powDexFaq.questions")?.map((item, i) => (
                  <div className="accordion-item" key={i}>
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#pow${i}`}
                        aria-expanded="false"
                        aria-controls={`pow${i}`}
                      >
                        {item.question}
                      </button>
                    </h2>
                    <div
                      id={`pow${i}`}
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">
                        {item.answer.includes("\n") ? (
                          <ul>
                            {item.answer.split("\n").map((indi, i) => (
                              <li key={i}>{indi}</li>
                            ))}
                          </ul>
                        ) : (
                          <ul>
                            <li>{item.answer}</li>
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-6 col-12 mt-lg-0 mt-md-4 mt-4">
              <div className="about-howto-create-token ">
                <h4>{translate("liquidityPoolFAQ.heading")}</h4>
              </div>
              <div
                className="accordion accordion-flush"
                id="accordionFlushExample"
              >
                {/* 1 */}
                {translate("liquidityPoolFAQ.questions")?.map((item, i) => (
                  <div className="accordion-item" key={i}>
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#liq-${i}`}
                        aria-expanded="false"
                        aria-controls={`liq-${i}`}
                      >
                        {item.question}
                      </button>
                    </h2>
                    <div
                      id={`liq-${i}`}
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">
                        {item.answer.includes("\n") ? (
                          <ul>
                            {item.answer.split("\n").map((indi, i) => (
                              <li key={i}>{indi}</li>
                            ))}
                          </ul>
                        ) : (
                          <ul>
                            <li>{item.answer}</li>
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* governance  */}
          <div className="row mt-4">
            <div className="col-lg-6 col-12">
              <div className="about-howto-create-token ">
                <h4>{translate("governanveFaq.heading")}</h4>
              </div>
              <div
                className="accordion accordion-flush"
                id="accordionFlushExample"
              >
                {/* 1 */}
                {translate("governanveFaq.questions")?.map((item, i) => (
                  <div className="accordion-item" key={i}>
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#gov-${i}`}
                        aria-expanded="false"
                        aria-controls={`gov-${i}`}
                      >
                        {item.question}
                      </button>
                    </h2>
                    <div
                      id={`gov-${i}`}
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">
                        {item.answer.includes("\n") ? (
                          <ul>
                            {item.answer.split("\n").map((indi, i) => (
                              <li key={i}>{indi}</li>
                            ))}
                          </ul>
                        ) : (
                          <ul>
                            <li>{item.answer}</li>
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-6 col-12 mt-lg-0 mt-md-4 mt-4">
              <div className="about-howto-create-token ">
                <h4>{translate("troubleShootFaq.heading")}</h4>
              </div>
              <div
                className="accordion accordion-flush"
                id="accordionFlushExample"
              >
                {/* 1 */}
                {translate("troubleShootFaq.questions")?.map((item, i) => (
                  <div className="accordion-item" key={i}>
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#tro-${i}`}
                        aria-expanded="false"
                        aria-controls={`tro-${i}`}
                      >
                        {item.question}
                      </button>
                    </h2>
                    <div
                      id={`tro-${i}`}
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">
                        {item.answer.includes("\n") ? (
                          <ul>
                            {item.answer.split("\n").map((indi, i) => (
                              <li key={i}>{indi}</li>
                            ))}
                          </ul>
                        ) : (
                          <ul>
                            <li>{item.answer}</li>
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
